import React from 'react';
import { IconProps } from '.';

const SvgMessage = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m2.99 16.344-.823 5.503 5.45-.856A9.965 9.965 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.554.356 3.029.99 4.344Zm.963 3.704.59-3.94-.202-.416a8.5 8.5 0 1 1 3.935 3.951l-.424-.207-3.9.612Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgMessage;
